// Agora Configuration
export interface AgoraConfig {
    appId: string;
    appCertificate?: string;
    tokenUrl?: string;
    uid?: number;
    useBackendTokens?: boolean;
}

// TODO: Replace with your actual Agora App ID from Agora Console
export const agoraConfig: AgoraConfig = {
    // Get this from Agora Console -> Project Settings
    appId: process.env.REACT_APP_AGORA_APP_ID || "YOUR_AGORA_APP_ID_HERE",

    // For production, implement a token server
    // For testing, you can use temporary tokens from Agora Console
    appCertificate: process.env.REACT_APP_AGORA_APP_CERTIFICATE,

    // Token server URL (NestJS backend)
    tokenUrl: process.env.REACT_APP_API_BASE_URL + "api/v1" || "http://localhost:3001/api",

    // Default UID (0 means auto-generate)
    uid: 0,

    // Use backend token server (true = use backend, false = use temp tokens)
    useBackendTokens: process.env.REACT_APP_USE_BACKEND_TOKENS === "true" || process.env.NODE_ENV === "production"
};

// Temporary token for testing (expires soon - only for development)
export const TEMP_TOKEN = "007eJxTYNj7q5Rn09NJz797f1yYz58lrfj7NLuqzd/uAFZPty2h8z8rMBiYpaYZpaQZGJqZm5okmaQkmZmYmZoZpJoZpaalGJsl1VzZmtEQyMiwZZYqAyMUgvgcDNn52dn5San5DAwAMVoiPQ==";
export const TEMP_CHANNEL = "kokkobeo";

// Channel configuration
export const channelConfig = {
    // Video configuration
    video: {
        // Video profile settings
        // 480p_1: 640×480, 15fps, 500kbps
        // 720p_1: 1280×720, 15fps, 1130kbps  
        // 1080p_1: 1920×1080, 15fps, 2080kbps
        profile: "480p_1",

        // Video encoder configuration
        width: 640,
        height: 480,
        frameRate: 15,
        bitrate: 500,
    },

    // Audio configuration
    audio: {
        // Audio profile
        // "music_standard": 48kHz, 48kbps, mono, encoding
        // "speech_low_quality": 16kHz, 24kbps, mono
        // "speech_standard": 32kHz, 24kbps, mono
        profile: "speech_standard",

        // Audio scenario
        scenario: "communication",

        // Enable 3A (AEC, AGC, ANS)
        enableAEC: true, // Acoustic Echo Cancellation
        enableAGC: true, // Automatic Gain Control  
        enableANS: true, // Automatic Noise Suppression
    },

    // Network and performance
    network: {
        // Network test before call
        enableNetworkTest: true,

        // Low latency mode
        enableLowLatency: true,

        // Adaptive bitrate
        enableAdaptiveBitrate: true,
    }
};

// Call states
export enum CallState {
    IDLE = "idle",
    CALLING = "calling",
    RINGING = "ringing",
    CONNECTED = "connected",
    ENDED = "ended",
    FAILED = "failed"
}

// Call types
export enum CallType {
    AUDIO = "audio",
    VIDEO = "video"
}

// Error codes mapping
export const AgoraErrorCodes = {
    INVALID_APP_ID: "INVALID_APP_ID",
    INVALID_CHANNEL_NAME: "INVALID_CHANNEL_NAME",
    TOKEN_EXPIRED: "TOKEN_EXPIRED",
    INVALID_TOKEN: "INVALID_TOKEN",
    CONNECTION_FAILED: "CONNECTION_FAILED",
    PERMISSION_DENIED: "PERMISSION_DENIED",
    DEVICE_NOT_FOUND: "DEVICE_NOT_FOUND"
};

export default agoraConfig;
